<template>
  <div class="main-page-container animate__animated animate__fadeIn animate__faster">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
  },
  data() {
    return {
      spinning: true,
    };
  },
  computed:{
    
  },
  mounted(){
  },
  methods:{
    
  }
};
</script>
<style lang="less" scoped>
</style>
